module.exports = __webpack_public_path__ + "img/mail.dc9699c6.svg";